import React, {useEffect, useRef, useState} from "react";
import FileUploadService from "~/services/FileUploadService";
import ReactPlayer from "react-player";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {
  CardContent, RCSGIFPreview, ReactVideoPlayer
} from "~/Pages/Campanhas/pages/Crud/Form/Components/PreviewCriativo/pages/RCSClaroPreview/components/RCSCard/styles";
import { ReactComponent as PlayButton }  from  '~/Assets/Images/play_arrow.svg'


const RCSCard = ({card, message, thumbnail, mainContent, playerRef, children}) => {
  const [image, setImage] = useState(undefined);
  const [media, setMedia] = useState(undefined);
  const [play, setPlay] = useState(false);

  playerRef.push({ current : { showPreview: () => setPlay(false)}});
  const newRef = useRef(null);
  const { valuePrefix, valueSuffix } = card;
  const loadFile =async (uuid, setFile ) => {
    const file = await FileUploadService.getFile(uuid);
    if(!file) return;
    setFile(await toBase64(file));
  }
  useEffect(() => {
    if(thumbnail) loadFile(thumbnail, setImage);
    else setImage(undefined)
    if(mainContent) loadFile(mainContent, setMedia);
    else setMedia(undefined);
  }, [mainContent, thumbnail]);

  const handleNewRef = () => {
    playerRef.push(newRef);
    return newRef;
  }

  return (
    <>
      <div className='card'>
        <ReactVideoPlayer className='player-wrapper'>
          { media && media.startsWith('data:video/mp4') &&
            <ReactPlayer
              ref={handleNewRef()}
              className='react-player'
              light={<img width='100%' height='100%' className='react-player' src={image} alt='Thumbnail'/>}
              width='100%'
              height='100%'
              url={media}
              controls={true}
            />
          }
          {
            media && media.startsWith('data:image/gif') &&
            <RCSGIFPreview onClick={() => setPlay(!play)} >
              <img src={play ? media: image} alt='image'/>
              { !play && <PlayButton/>}
            </RCSGIFPreview>
          }
          {
            media && media.startsWith('data:image') && !media.startsWith('data:image/gif') &&
            <RCSGIFPreview >
              <img src={media} alt='image'/>
            </RCSGIFPreview>
          }
        </ReactVideoPlayer>
        <CardContent>
          <h2>{valuePrefix}</h2>
          <p>
            {`${message} ${valueSuffix}`}
          </p>
          {children}
        </CardContent>
      </div>
    </>
  );
}

const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => bindActionCreators(
  {},
  dispatch,
);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RCSCard);

